import { createFileRoute, Link } from '@tanstack/react-router';
import { CirclePlus } from 'lucide-react';
import { Page, useGetPagesQuery } from '@/api/pages/getPages';
import { PageContainer } from '@/components/layout/PageContainer';
import { PageHeader } from '@/components/layout/PageHeader';
import { ContentCard } from '@/components/layout/ContentCard';
import { DataTable } from '@/components/data/DataTable';
import { Button } from '@/components/ui/button';

type PageTableRow = Page & Record<string, unknown>;

export const Route = createFileRoute('/dashboard/pages/')({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = Route.useNavigate();

  const { data: pages = [] } = useGetPagesQuery();
  const pageRows: PageTableRow[] = pages.map(page => ({ ...page }));

  return (
    <PageContainer>
      <PageHeader
        title="Pages"
        subtitle=""
        actions={
          <Link to="/dashboard/pages/$id" params={{ id: 'new' }}>
            <Button>
              <CirclePlus className="h-4 w-4" />
              Add Page
            </Button>
          </Link>
        }
      />

      <ContentCard>
        <div className="space-y-4">
          <DataTable
            data={pageRows}
            columns={[
              {
                id: 'page_type',
                name: 'Key',
                render: page => page.page_type,
              },
            ]}
            actions={[
              {
                label: 'Edit',
                onClick: page => {
                  navigate({
                    to: '/dashboard/pages/$id',
                    params: { id: page.id },
                  });
                },
              },
            ]}
            isLoading={false}
            emptyMessage="No pages found"
          />
        </div>
      </ContentCard>
    </PageContainer>
  );
}
